import { colorSchemeTokens } from '@sixui/ui/themes/base/colorScheme.stylex';
import { shapeTokens } from '@sixui/ui/themes/base/shape.stylex';
import stylex from '@stylexjs/stylex';

import type { IContainerProps } from '~/components/utils/Container';

export type IColorProps = IContainerProps & {
  hex?: string;
};

const styles = stylex.create({
  host: {
    width: 40,
    height: 40,
    flexShrink: 0,
    flexGrow: 0,
    borderRadius: shapeTokens.corner$full,
    backgroundColor: 'transparent',
  },
  backgroundColor: (hex: string) => ({
    backgroundColor: hex,
  }),
  undefined: {
    borderWidth: '1px',
    borderStyle: 'solid',
    borderColor: colorSchemeTokens.outlineVariant,
  },
});

export const Color: React.FC<IColorProps> = (props) => {
  const { sx, hex } = props;

  return (
    <div
      {...stylex.props(
        styles.host,
        hex ? styles.backgroundColor(hex) : styles.undefined,
        sx,
      )}
    />
  );
};
